import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_CUSTOMER_ADDRESS } from "../customer-address.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateCustomerAddressInput } from "../../../__generated__/globalTypes";
import {
  CreateCustomerAddressMutation,
  CreateCustomerAddressMutationVariables,
} from "../../../__generated__/CreateCustomerAddressMutation";

interface IProps {
  defaultValues: DeepPartial<CreateCustomerAddressInput>;
  onCompleted: () => any;
}

export const useCreateCustomerAddress = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateCustomerAddressInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateCustomerAddressMutation,
    CreateCustomerAddressMutationVariables
  >(CREATE_CUSTOMER_ADDRESS, {
    refetchQueries: ["CustomerAddressesQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createCustomerAddress?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createCustomerAddress?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
